import React, { useContext, useState } from "react";

import { useStaticQuery, graphql, Link } from "gatsby";



import SEO from "../components/seo";
import Layout from "../components/layout";
import useSiteMetadata from "../utils/useSiteMetadata"
import CustomMarkdown from "../utils/customMarkdown"
// import "../components/layout.css"

// import Signup from "../components/signup";
// import Hero from "../components/basic-components/hero";
// import Tiles from "../components/tiles";
// import CustomCollectionsBar from "../components/custom-collections-bar";

import Img from "gatsby-image";
import CTAImg from "../assets/img/Help-you-scaled-e1588324743844.jpg";

// import { AppContext, useGlobalContext } from "../utils/context"
import GetImgUrl, { abc } from "../utils/customFunctions";
// import SubheadingText from "../components/basic-components/subheading-text";

import loadable from '@loadable/component'
//import { hasImageLoaded } from "gatsby-plugin-image/dist/src/components/hooks";
// import Branches from "../components/branches-component";

const CustomCollectionsBar = loadable(() => import("../components/custom-collections-bar"))
const Branches = loadable(() => import("../components/branches-component"))
const Tiles = loadable(() => import("../components/tiles"))
const Hero = loadable(() => import("../components/basic-components/hero"))
const Signup = loadable(() => import("../components/signup"))
const SubheadingText = loadable(() => import("../components/basic-components/subheading-text"))
const QuoteCarousel = loadable(() => import("../components/quote-carousel"))
const Paragraph = loadable(() => import("../components/paragraph"))
const VideoComponent = loadable(() => import("../components/video-component"))
const StepsComponent = loadable(() => import("../components/steps-component"))
const FAQComponent = loadable(() => import("../components/faq-component"))
const SwirlComponent = loadable(() => import("../components/swirl-component"))
const MapComponent = loadable(() => import("../components/map-component"))
const BranchLocator = loadable(() => import("../components/branch-locator"))
const InfiniteImageCarousel = loadable(() => import("../components/infinite-image-carousel"))
const InfiniteTextCarousel = loadable(() => import("../components/infinite-text-carousel"))

const IndexPage = () => {
  // const {getImgUrl} = useGlobalContext()
  // getImgUrl("asd")
  // console.log(GetImgUrl("a8026070-072a-586e-b423-2c9b261c378e"))

  const data = useStaticQuery(graphql`
    {
      allJrmProducts(limit: 5) { 
        nodes {
          Id
          Name
          AttractivePrice
          Description
          Slug
        }
      }

      strapiHomepage {
        SEOTitle
        SEODescription
        Canonical
        MetaTags{
          MetaName
          MetaContent
        }
        Header {
          Visible
          URL
          Title
          Subtitle
          CTA
          Subheading
          SubheadingSummary
          LeftBgColor
          RightBgColor
          Background {
            url
            localFile {
              childImageSharp {
                fluid(quality: 90, maxWidth: 1900) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          CTASecondary
          URLSecondary
          BottomMargin
        }
        CustomCollection {
          Title
          CustomCollectionTile {
            Title
            Slug
            Subtitle
            Link
            id
            Media {
              url
              localFile {
                childImageSharp {
                  fluid(quality: 90, maxWidth: 1900) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            Item {
              id
              Reference
            }
          }
        }
        PageComponents
      }

      strapiCollections {
        Title
        id
        CustomCollectionTile {
          Title
          Subtitle
          Link
          id
          Media {
            url
            localFile {
              childImageSharp {
                fluid(quality: 90, maxWidth: 1900) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          Item {
            id
            Reference
          }
        }
      }
    }
  `);

  var headerData = data.strapiHomepage.Header != null ? {
    headerTitle: data.strapiHomepage.Header.Title,
    headerDescription: data.strapiHomepage.Header.Subtitle,
    headerCTAPrimaryLabel: data.strapiHomepage.Header.CTA,
    headerCTAPrimaryUrl: data.strapiHomepage.Header.URL,
    headerCTASecondaryLabel: data.strapiHomepage.Header.CTASecondary,
    headerCTASecondaryUrl: data.strapiHomepage.Header.URLSecondary,
    headerBgImage:
      data.strapiHomepage.Header.Background.localFile.childImageSharp.fluid,
    headerRightBgColor: data.strapiHomepage.Header.RightBgColor ? data.strapiHomepage.Header.RightBgColor : '',
    headerLeftBgColor: data.strapiHomepage.Header.LeftBgColor ? data.strapiHomepage.Header.LeftBgColor : '',
    headerBottomMargin: data.strapiHomepage.Header.BottomMargin != null ? data.strapiHomepage.Header.BottomMargin : true,
  } : {};

  var singleCTAData = [
    {
      Background: {
        publicURL: CTAImg,
      },
      Title: "Artisan craftmanship",
      url: "#0",
    },
  ];

  // const branches = data.strapiHomepage.HomepageSections.filter((item) => item.BranchesList)
  // const branchList = branches ? branches[0]?.BranchesList : []

  const { siteUrl: url } = useSiteMetadata();

  const pageHasHeader = data.strapiHomepage.Header != null ? true : false; //check if Header is set
  const [headerParagraphSet, setHeaderParagraphSet] = useState(false);

  //console.log("PageComponents: ", data.strapiHomepage.PageComponents);
  return (
    <div>
      
      <Layout
        pageData={headerData}
        headerShow={data.strapiHomepage.Header != null ? data.strapiHomepage.Header.Visible :false}
      >
        <SEO title={data.strapiHomepage.SEOTitle} description={data.strapiHomepage.SEODescription} 
             meta={data.strapiHomepage.MetaTags}
             canonical={data.strapiHomepage.Canonical ? data.strapiHomepage.Canonical : `${url}`}/>

        {/* <Tiles></Tiles> */}

        {/* <Carousel title={carouselContents.carouselTitle}></Carousel> */}
        {/* <Carousel title={"Memorials for all"} data={data.allJrmProducts.nodes} url="/collections"></Carousel> */}

        {/* <br/> */}
        {data.strapiHomepage.Header != null ?
          (data.strapiHomepage.Header.Subheading != null && data.strapiHomepage.Header.Subheading != '' ? 
          <SubheadingText
            subheading={data.strapiHomepage.Header.Subheading}
            summary={data.strapiHomepage.Header.SubheadingSummary}
            endLine={false} 
            sectionStyle="white"/> : '')

            : ''
        }   

        {/* {data.strapiHomepage.HomepageSections.map((item, index) => {
          return (
            <div key={index}>
   
              {item.Hero ? (
                <Hero
                  title={item.Hero.Title}
                  description={item.Hero.Description}
                  label={item.Hero.Label}
                  url={item.Hero.url}
                  key={index}
                  sectionStyle = "white"
                ></Hero>
              ) : (
                ""
              )}
            </div>
          );
        })} */}

        {/* {branchList ? <Branches branchList={branchList} sectionStyle="dark" /> : ''} */}

        {/* this is the collection bar on the homepage that comes from the user selection relation in the top right dropdown in strapi */}
        {/* <CustomCollectionsBar title={"Memorials for all"} data={data.strapiHomepage.CustomCollection} url="/collections"></CustomCollectionsBar> */}

        {/* <Tiles data={data.strapiHomepageCta.HomepageCTA}></Tiles> */}

        {/* <Tiles data={singleCTAData} singleFlag={true}></Tiles> */}

        {/* {data.strapiHomepage.HomepageSections.map((item, index) => {
          return (
            <div key={index}>
              {item.CTA !== undefined && item.CTA.length > 1 ? (
                <Tiles data={item.CTA} width='half' key={index} sectionStyle="dark"></Tiles>
              ) : (
                ""
              )}

              {
                item.CTA !== undefined && item.CTA.length === 1 ? (
                  <Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle="white"></Tiles>
                ) : (
                  ""
                )
                // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                //don't forget to fix this once the cta.length of a json (dynamic zone) is found
              }

              {item.Testimonial 
                  ? (<div className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                    ) 
                  : (
                    ""
                  )}

            </div>
          );
        })} */}


         {data.strapiHomepage.PageComponents.map((item, index) => {          
            switch (item.strapi_component) {
              case "basic-components.paragraph":
                var forceH1Title = false;
                var overlaySwirl = false;
                var overlaySubstractTransform = true;
              
                if((pageHasHeader == false && headerParagraphSet == false) || item.IsHeader == true){
                  setHeaderParagraphSet(true);
                  forceH1Title = true;
                }

                if(index == 0 && item.TopSwirl == true){ //if paragraph is the first item in pageComponents and has topSwirl then overlay the header image
                  overlaySwirl = true;
                }
                
                if(data.strapiHomepage.Header.BottomMargin == false){
                  overlaySubstractTransform = false;
                }
                return (
                    <Paragraph
                        key={index}
                        title={item.Title}
                        text={item.Text}
                        image={item.Image}
                        imagePosition={item.ImagePosition}
                        bgColor={item.BackgroundColor || ""}
                        topPadding={(item.TopPadding === true) ? true : false}
                        bottomPadding={(item.BottomPadding === true) ? true : false}
                        forceH1Title={forceH1Title}
                        alignment={item.ContentAlignment}
                        initialPadding={item.InitialPadding}
                        topSwirl={item.TopSwirl}
                        bottomSwirl={item.BottomSwirl}
                        bottomMargin={item.BottomMargin}
                        overlaySwirl={overlaySwirl}
                        leftPadding={item.LeftPadding}
                        rightPadding={item.RightPadding}
                        overlaySubstractTransform={overlaySubstractTransform}
                    ></Paragraph>                                
                )
              case "basic-components.hero-section":
                return(
                  <Hero
                    title={item.Hero.Title}
                    description={item.Hero.Description}
                    label={item.Hero.Label}
                    url={item.Hero.url}
                    key={index}
                    sectionStyle = "white"
                  ></Hero>
                )
              case "basic-components.branches-component":
                const branchesBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                return(
                  <Branches key={index} branchList={item.BranchesList} title={item.Title} sectionStyle={branchesBgColor} />
                )
              case "basic-components.video-section":
                return(
                  <VideoComponent key={index} src={item.YoutubeURL}/>
                )
              case "basic-components.testimonial-section":
                return(
                    <div key={index} className="">
                      <QuoteCarousel quoteList={item.Testimonial}></QuoteCarousel>
                    </div>
                )
              case "cta.cta-section":
                const sectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark'; 
                const fullWidthSectionBgColo =  item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'white'; 
                return(
                  <div key={index}>
                    {item.CTA !== undefined && item.CTA.length > 1 ? (<Tiles data={item.CTA} width='half' key={index} sectionStyle={sectionBgColor}></Tiles>) : ("")}

                    {item.CTA !== undefined && item.CTA.length === 1 ? (<Tiles data={item.CTA} key={index} singleFlag={true} width='full' sectionStyle={fullWidthSectionBgColo}></Tiles>) : ("")
                      // (item.CTA !== null && Object.keys(item.CTA).length === 1)?<Tiles data={item.CTA} singleFlag={true}></Tiles>:""
                      //don't forget to fix this once the cta.length of a json (dynamic zone) is found
                    }
                  </div>
                )
              case "basic-components.text-section":
                return (               
                  item.Text ? (
                    <>
                      <CustomMarkdown key={index} children={item.Text} />
                          {item.Links 
                            ?<Link to={`${item.Links.URL}`}>
                                 {item.Links.Link}
                              </Link>  
                            : ''}
                    </>
                  ) : (
                    ""
                  )
                )
              case "basic-components.image-carousel":
                return (               
                  item.Images 
                    ? ( <div key={index} className="image_wrap">
                      <div className="image-section uk-cover-container uk-margin-none">
                        <Img
                          fluid={GetImgUrl(item.Images.localFile___NODE).fluid}
                          alt={"image"}
                          data-uk-cover
                        ></Img>
                      </div>
                    </div>
                    ) 
                    : ("")
                )
              case "basic-components.image-carousel-section":
                return(
                    item.ImageCarousel ? (
                        <div key={index} className="image-section uk-height-medium uk-cover-container uk-margin-none">
                          <Img
                            fluid={
                              GetImgUrl(item.ImageCarousel.Images.localFile___NODE)
                                .fluid
                            }
                            alt="image"
                          ></Img>
                        </div>
                    ) : null
                )
              case "basic-components.steps-component":
                return(
                  <StepsComponent key={index} stepsList={item.StepsList} sectionStyle="white" />
                )
              case "basic-components.faq-component":
                return(
                  <FAQComponent key={index} faqList={item.FAQList} sectionStyle="white" />
                )
              case "basic-components.collection-component":    
                const collectionBgColor = item.BackgroundColor != null ? item.BackgroundColor.toLowerCase() : 'dark';           
                return(
                  data.strapiHomepage.CustomCollection != null ?
                      <CustomCollectionsBar
                        title={data.strapiHomepage.CustomCollection.Title}
                        description={data.strapiHomepage.CustomCollection.Description}
                        data={data.strapiHomepage.CustomCollection}
                        url="/collections"
                        btnText="See all collections"
                        sectionStyle={collectionBgColor}
                    ></CustomCollectionsBar>
                : ''
                )
              case "basic-components.signup-component":
                return(
                  <Signup
                    title="Sign Up to Our Newsletter"
                    description="Get updates on all the lastest information, or stay informed about our courses"
                    buttonLabel="Sign Up"
                    sectionStyle = "white"
                  />
                )
              case "basic-components.swirl-component":                
                return(
                  <SwirlComponent 
                    key={index} 
                    bgColor={item.SwirlColor} topSwirl={item.Position == "Top" ? true : false} 
                    />
                )
              case "basic-components.map-component":                
                return(
                  <MapComponent 
                    key={index} 
                    title={item.Title}
                    gMapsLocation={item.GMapsLocation} 
                    />
                )
              case "basic-components.branch-locator":                
                return(
                  <BranchLocator 
                    key={index} 
                    title={item.Title}
                    subtitle={item.Subtitle}
                    branchesList={item.Branches} 
                    />
                )
              case "basic-components.infinite-image-carousel":                
                return(
                  <InfiniteImageCarousel 
                    key={index} 
                    title={item.Title}
                    imageList={item.LinkImageList} 
                    backgroundColor={item.BackgroundColor}
                    />
                )
              case "basic-components.infinite-text-carousel":                
                return(
                  <InfiniteTextCarousel 
                    key={index} 
                    title={item.Title}
                    textList={item.LinkTextList} 
                    backgroundColor={item.BackgroundColor}
                    />
                )
              default:
                return ('')
          }
        }
        )} 

        
      </Layout>
    </div>
  );
};

export default IndexPage;
